export default __webpack_public_path__ + "static/SELFLOVEALWAYS_BLUE-82a5a7ee7cd22545d4e430c031e5b6aa.png";